import FloatingBackButton from "../components/FloatingBackButton";
import ParallaxPage from "../components/ParallaxPage";
import visionsContent from "./visions-content.json";
import {Spacer} from "../components/Spacer";
import startContent from "./start-content.json";
import React from "react";
import {ParagraphsComponent} from "../components/ParagraphsComponent";

export const Visions = () => {
    return (
        <div>
            <FloatingBackButton/>
            <ParallaxPage
                imageUrl={startContent.visions.imageUrl}
                content={
                    <div>
                        <h1>{visionsContent.title}</h1>
                        <h2>{visionsContent.subtitle}</h2>
                        <Spacer height={100}/>
                        <ParagraphsComponent paragraphs={visionsContent.paragraphs} />
                    </div>
                }
            />
        </div>
    );
};